"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCallback = void 0;
/** Amplify handles everything for us - we just need this route to exist / not 404 */
function GoogleCallback() {
    return null;
}
exports.GoogleCallback = GoogleCallback;
//# sourceMappingURL=GoogleCallback.js.map